import { useMemo, useState } from 'react'
import axios from 'axios'
import { LoadingPage } from '../LoadingPage'
import * as S from './styles';
import * as G from '../../theme/global-styles';
import ClientLogo from '../../components/ClientLogo';
import PoweredByQITech from '../../components/PoweredByQITech';
import { ThemedButton } from '../../components/ThemedButton';
import { useThemeContext } from "../../contexts/ThemeContext";
import { ErrorPage } from '../ErrorPage';

export const GenericTerm = ({
    signData,
    setSignerStep,
    setSignData,
}: {
    signData: any,
    setSignerStep: (step: string) => void,
    setSignData: (data: any) => void,
}) => {

    const { clientThemeSettings } = useThemeContext();

    const [error, setError] = useState({ has_error: false, status: null })
    const [loading, setLoading] = useState(false)
    const [markedCheckboxes, setMarkedCheckboxes] = useState([]);

    const buttonDisabled = useMemo(() => (
        Array.isArray(signData.generic_term_data?.checkboxes) 
        && signData.generic_term_data?.checkboxes?.some(
            (checkbox: { required: boolean, label: string }, index: number) => checkbox?.required && !markedCheckboxes.includes(index)
        )
    ), [signData.generic_term_data?.checkboxes, markedCheckboxes]);

    const handleToggleCheckbox = (index: number) => {
        if (markedCheckboxes.includes(index)) {
            setMarkedCheckboxes(markedCheckboxes.filter((c: number) => c !== index));
        } else {
            setMarkedCheckboxes([...markedCheckboxes, index]);
        }
    }

    const handleClick = async () => {

        if (loading || buttonDisabled) {
            return  
        }
        
        const payload = {
            "step": "generic_term",
            "event_date": new Date().toISOString(),
        }
    
        const config = {
            headers:
            {
                'Authorization': signData.signer_token
            }
        }
    
        setLoading(true);

        try {
            const response = await axios.patch('/signer', payload, config);
            setSignerStep(response.data.next_step)
            setSignData({ ...signData, ...response.data })
        } catch (error) {
            if ([401, 403].includes((error.response || {}).status)) {
                setError({
                    has_error: true,
                    status: error.response.status
                })
            } else {
                setError({
                    has_error: true,
                    status: 500
                })
            }
        } finally {
            setLoading(false)
        }
    }

    if (loading) {
        return (
            <LoadingPage />
        )
    }

    return (
        <G.Container style={{padding: "16px 0"}}>
            <ClientLogo clientThemeSettings={clientThemeSettings} size="small" />
            <S.TermContainer>
                <G.Title>{signData.generic_term_data.title}</G.Title>
                <S.Description>{signData.generic_term_data.description}</S.Description>
                {Array.isArray(signData.generic_term_data.checkboxes) && signData.generic_term_data.checkboxes.length > 0 && (
                    <S.CheckboxesContainer>
                        {signData.generic_term_data.checkboxes.map((checkbox, index) => (
                            <S.CheckboxContainer key={index}>
                                <input type="checkbox" checked={markedCheckboxes.includes(index)} onClick={() => handleToggleCheckbox(index)} />
                                <S.CheckboxLabel>{checkbox.label}
                                    {checkbox.required && (
                                        <S.RequiredText>✱</S.RequiredText>
                                    )}
                                </S.CheckboxLabel>
                            </S.CheckboxContainer>
                        ))}
                        {signData.generic_term_data.checkboxes.some(checkbox => checkbox.required) && (
                            <S.RequiredTextContainer>
                                <S.RequiredText>✱  Campos obrigatórios</S.RequiredText>
                            </S.RequiredTextContainer>
                        )}
                    </S.CheckboxesContainer>
                )}
            </S.TermContainer>
            <S.Footer>
                <ThemedButton
                    clientThemeSettings={clientThemeSettings}
                    loading={false}
                    onClick={handleClick}
                    disabled={buttonDisabled}
                >
                    Aceitar e continuar
                </ThemedButton>
                <PoweredByQITech />
            </S.Footer>
            {error?.has_error &&
                <ErrorPage
                    error={error}
                    redirectToLogin={() => setSignerStep("login")}
                    resetError={() => setError({ has_error: false, status: null })}
                    clientThemeSettings={clientThemeSettings}
                />
            }
        </G.Container>
    );
};